import { Box, CircularProgress, Typography } from '@mui/material';
import jyBlackLogo from '../assets/JY BLACK.png';

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'linear-gradient(135deg, #e3f0ff 0%, #fafcff 100%)',
        zIndex: 9999,
        gap: 3
      }}
    >
      <img 
        src={jyBlackLogo} 
        alt="JY Logo" 
        style={{ 
          width: '120px', 
          height: 'auto',
          marginBottom: '20px'
        }}
      />
      <CircularProgress 
        size={50} 
        thickness={4} 
        sx={{ 
          color: 'primary.main',
          mb: 2
        }}
        aria-label="Loading application" 
      />
      <Typography 
        variant="h5" 
        color="text.primary" 
        sx={{ 
          fontWeight: 600,
          textAlign: 'center',
          mb: 1
        }}
      >
        Welcome to JY WMS
      </Typography>
      <Typography 
        variant="body1" 
        color="text.secondary" 
        sx={{ 
          textAlign: 'center',
          maxWidth: 300
        }}
      >
        Loading your workspace...
      </Typography>
    </Box>
  );
};

export default LoadingScreen; 